<template>
  <v-app style="background-color:white">
    <v-card class="form-container">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-switch v-model="edit" label="Want to edit ?" color="primary" hide-details></v-switch>
          </v-flex>  
            <v-flex xs12 sm12 md6 style="padding-right:5px">
            <v-text-field
              :disabled="edit == false"
              :rules="emptyRule"
              v-model="form.companyName"
              label="Company name"
              required
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6 style="padding-right:5px">
            <v-text-field :disabled="edit == false" v-model="form.companyCode" label="Company code"></v-text-field>
            </v-flex>
            
            <v-text-field :disabled="edit == false" v-model="form.gstNumber" label="GST number"></v-text-field>
            <v-text-field :disabled="edit == false" v-model="form.panNumber" label="PAN number"></v-text-field>
            <v-text-field :disabled="edit == false" v-model="form.email" label="Email"></v-text-field>
            <v-text-field :disabled="edit == false" v-model="form.contactName" label="Contact name"></v-text-field>
            <v-text-field
              :disabled="edit == false"
              v-model="form.contactNumber"
              label="Contact number"
            ></v-text-field>
          </v-flex>

          <!-- BILLING  -->
          <v-flex xs12 md6 sm6 style="padding-right: 5px">
            <v-text-field :disabled="edit == false" v-model="form.billingCity" label="Billing city"></v-text-field>
            <v-text-field
              :disabled="edit == false"
              v-model="form.billingCountry"
              label="Billing country"
            ></v-text-field>
            <v-text-field
              :disabled="edit == false"
              v-model="form.billingZipCode"
              label="Billing zip code"
            ></v-text-field>
            <v-autocomplete
              :disabled="edit == false"
              v-model="selectedBillingState"
              :items="states"
              color="primary"
              label="Select billing state *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
            <v-textarea
              :disabled="edit == false"
              v-model="form.billingAddress"
              label="Billing address"
            ></v-textarea>
          </v-flex>

          <!-- SHIPPING -->
          <v-flex xs12 md6 sm6 style="padding-left: 5px">
            <v-text-field
              :disabled="edit == false"
              v-model="form.shippingCity"
              label="Shipping city"
            ></v-text-field>
            <v-text-field
              :disabled="edit == false"
              v-model="form.shippingCountry"
              label="Shipping country"
            ></v-text-field>
            <v-text-field
              :disabled="edit == false"
              v-model="form.shippingZipCode"
              label="Shipping zip code"
            ></v-text-field>
            <v-autocomplete
              :disabled="edit == false"
              v-model="selectedShippingState"
              :items="states"
              color="primary"
              label="Select shipping state *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
            <v-textarea
              :disabled="edit == false"
              v-model="form.shippingAddress"
              label="Shipping address"
            ></v-textarea>
          </v-flex>
          <v-flex xs12 style="text-align:right">
            <v-btn :disabled="edit == false" color="#E4573D" depressed dark @click="back()">Cancel</v-btn>
            <v-btn :disabled="edit == false" :loading="btnSave" color="primary" depressed dark @click="saveForm()">Save</v-btn>
            
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      edit: false,
      valid: true,
      btnSave: false,
      emptyRule: [v => !!v || "Input is required"],
      form: {
      },
      search: "",
      
      states: null,
      selectedBillingState: null,
      selectedShippingState: null,
    };
  },

  methods: {
    back() {
      this.$router.go(-1);
    },
    getData() {
      let id = this.$route.params.id;
      this.axios
        .get(config.API + `Companies/${id}`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.form = res.data;
          this.selectedBillingState = res.data.billingStateCode;
          this.selectedShippingState = res.data.shippingStateCode;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.$Progress.fail();
        });
    },

    saveForm() {
      let id = this.$route.params.id;
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `Companies/${id}`,
            {
              id: JSON.parse(id),
              billingAddress: this.form.billingAddress,
              billingCity: this.form.billingCity,
              billingCountry: this.form.billingCountry,
              billingStateCode: JSON.parse(this.selectedBillingState),
              billingStreet: this.form.billingStreet,
              billingZipCode: JSON.parse(this.form.billingZipCode),
              companyCode: this.form.companyCode,
              companyName: this.form.companyName,
              contactName: this.form.contactName,
              contactNumber: JSON.parse(this.form.contactNumber),
              email: this.form.email,
              gstNumber: this.form.gstNumber,
              panNumber: this.form.panNumber,
              shippingAddress: this.form.shippingAddress,
              shippingCity: this.form.shippingCity,
              shippingCountry: this.form.shippingCountry,
              shippingStateCode: JSON.parse(this.selectedShippingState),
              shippingStreet: this.form.shippingStreet,
              shippingZipCode: JSON.parse(this.form.shippingZipCode)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Company update successful");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      }
    }
  },

  mounted() {
    this.$Progress.start();
    this.getData();
    this.axios
        .get(config.API + `States`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.states = res.data;
          this.$Progress.finish();
        });
  }
};
</script>
